import classNames from 'classnames'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import moment from 'moment'
import IconSVG from 'svg-inline-react'
import UISelect from 'components/shared/UISelect'
import { Hours, HOUR_OPTIONS, HOUR_FORMAT, DAY_OPTIONS } from 'components/Customize/Availability/Constants'
import style from './style'

function isValidAvailability(opens, closes) {
  return moment(opens, HOUR_FORMAT) < moment(closes, HOUR_FORMAT)
}

class TimeSelect extends Component{
  render() {
    const {day, opens, closes, onRemove} = this.props
    const invalid = !isValidAvailability(opens, closes)

    return (
      <div className={style.TimeSelect}>
        <UISelect
            value={day}
            options={DAY_OPTIONS}
            className={style.DaySelect}
            onSelection={this.onSelectDayOfWeek}
        />
        from
        <UISelect
            value={opens}
            options={HOUR_OPTIONS}
            className={classNames(style.HourSelect, {invalid})}
            onSelection={this.onSelectOpens}
        />
        to
        <UISelect
            value={closes}
            options={HOUR_OPTIONS}
            className={classNames(style.HourSelect, {invalid})}
            onSelection={this.onSelectCloses}
        />
        <a onClick={onRemove}
           style={{ width: 11, height: 11 }}>
          <IconSVG src={ require('!svg-inline?removeTags=true!images/icons/times-icon-gray.svg') }
          />
        </a>
      </div>
    )
  }

  onSelectDayOfWeek = ({value}) => {
    this.props.onSelection('dayOfWeek', value)
  }

  onSelectOpens = ({value}) => {
    this.props.onSelection('opens', value)
  }

  onSelectCloses = ({value}) => {
    this.props.onSelection('closes', value)
  }
}

class MultiTimeSelect extends Component {
  static propTypes = {
    openHours: ImmutablePropTypes.listOf(Hours).isRequired,
    onSelection: PropTypes.func.isRequired,
    onRemoveTime: PropTypes.func.isRequired,
    onAddTime: PropTypes.func.isRequired,
  }

  render() {
    const { openHours, onAddTime } = this.props
    const valid = this.isValid(openHours)

    const timeSelects = openHours.map((hoursSet, index) => {
      return (
        <TimeSelect
          key={`multi-time-select-${index}`}
          day={hoursSet.get('dayOfWeek')}
          opens={hoursSet.get('opens')}
          closes={hoursSet.get('closes')}
          onSelection={this.handleSelect(index)}
          onRemove={this.handleRemoveTime(index)}
        />
      )}
    )

    return (
      <div className={style.MultiTimeSelect}>
        { this.renderInvalidLabel(valid) }
        {timeSelects}
        <a className="add-time" onClick={onAddTime}>
          + Add time
        </a>
      </div>
    )
  }

  renderInvalidLabel(valid) {
    if (!valid) {
      return (
        <div className="invalid-label">Your start time must be before your finish time</div>
      )
    }
  }

  handleSelect = (index) => (key, value) => {
    const { openHours, onSelection } = this.props
    const valid = this.isValid(openHours.setIn([index, key], value))
    return onSelection(index, key, value, valid)
  }

  handleRemoveTime = (index) => () => {
    const valid = this.isValid(this.props.openHours.delete(index))
    this.props.onRemoveTime(index, valid)
  }

  isValid(hours) {
    return hours.reduce((result, hoursSet) => {
      return result && isValidAvailability(hoursSet.get('opens'), hoursSet.get('closes'))
    }, true)
  }
}

export default MultiTimeSelect



// WEBPACK FOOTER //
// ./src/scripts/components/settings/ChatWidget/components/HoursAndTargeting/MultiTimeSelect/index.js